import { rewardReqWithoutLogin } from '@/utils/request';
export function analyticFun(data){
    return rewardReqWithoutLogin({
        url: '/cook-manage-admin/api/mau/analytic',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/finger.js